<template>
    <div
        :class="[
            'currency-cell',
            {
                positive: isPositive,
                negative: isNegative,
            },
            !editable ? 'disabled text-right' : '',
        ]"
    >
        <vue-numeric
            ref="vue_numeric"
            :class="['form-control', inputStyle]"
            :read-only="readonly"
            :disabled="!editable"
            :read-only-class="inputStyleClass"
            :currency="currency"
            :min="minNumber"
            :max="maxNumber"
            :minus="negative"
            :setToMinValue="setToMinValue"
            :precision="decimal"
            :field="id"
            :id="id"
            :placeholder="placeholder"
            output-type="Number"
            :value="amount"
            :style="displayMax && max != null ? inputWrapperStyle : null"
            @change="editable ? changeHandler($event.target.value) : null"
            @input="inputHandler"
        >
        </vue-numeric>
        <span
            v-if="displaySuffix"
            class="input-suffix"
        >
            {{ inputSuffix }}
        </span>
        <template v-if="displayMax && max != null">
            <span class="max-num"> / {{ maxNumber }} </span>
        </template>
    </div>
</template>

<script>
import VueNumeric from "vue-numeric";

export default {
    components: { VueNumeric },
    props: {
        decimal: {
            type: Number,
            default: 0,
        },
        currency: {
            type: String,
            default: "",
        },
        negative: {
            type: Boolean,
            default: false,
        },
        sign: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Number,
        },
        max: {
            type: Number,
        },
        displayMax: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        eager: {
            type: Boolean,
            default: false,
        },
        inputStyle: {
            type: [String, Array],
            default: "",
        },
        setToMinValue: {
            type: Boolean,
            default: false,
        },
        displaySuffix: {
            type: Boolean,
            default: false,
        },
        inputSuffix: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
    },

    model: {
        prop: "value",
        event: "change",
    },

    components: {
        VueNumeric,
    },

    computed: {
        amount: {
            get() {
                return this.parseNumber(this.value);
            },
            set(newValue) {
                this.changedValue(newValue);
            },
        },
        isPositive: function () {
            return this.negative && this.value > 0;
        },
        isNegative: function () {
            return this.negative && this.value < 0;
        },
        inputStyleClass: function () {
            let style = this.inputStyle;

            if (this.inputStyle instanceof Array) {
                style = this.inputStyle.join(" ");
            }

            style.concat(", ", "form-control");
            return style;
        },
        minNumber: function () {
            const min = this.min ?? Number.MIN_SAFE_INTEGER;

            if (min < 0) {
                return this.negative ? min : 0;
            }

            return min;
        },
        maxNumber: function () {
            if (this.max === "" || this.max === null || typeof this.max == "undefined") {
                return Number.MAX_SAFE_INTEGER;
            }

            return this.max;
        },
        inputWrapperStyle() {
            const maxNumLength = this.maxNumber ? this.maxNumber.toString().length : 1;
            const paddingRight = `${Math.min(maxNumLength * 10 + 12, 100)}px`;
            return {
                paddingRight,
            };
        },
    },

    methods: {
        parseNumber(value) {
            if (typeof value === "number") return value;
            if (typeof value === "string" && value !== "") return parseFloat(value);
            return "";
        },

        changedValue(value) {
            if (this.eager || this.value !== value) {
                this.$emit("input", value);
            }
        },

        inputHandler(value) {
            if (value !== "") this.changedValue(value);
        },

        changeHandler(value) {
            this.process(this.$refs["vue_numeric"].unformat(value));
        },

        process(value) {
            if (typeof value === "string" && value === "" && !this.setToMinValue) {
                this.$emit("change", value);
            } else {
                if (typeof value === "string" && value === "" && this.setToMinValue) {
                    this.$emit("change", Number(this.minNumber.toFixed(this.decimal)));
                }
                if (value >= this.maxNumber) this.$emit("change", Number(this.maxNumber.toFixed(this.decimal)));
                if (value <= this.minNumber) this.$emit("change", Number(this.minNumber.toFixed(this.decimal)));
                if (value > this.minNumber && value < this.maxNumber)
                    this.$emit("change", Number(value.toFixed(this.decimal)));
                if (!this.negative && value < 0)
                    this.minNumber >= 0
                        ? this.$emit("change", Number(this.minNumber.toFixed(this.decimal)))
                        : this.$emit("change", 0);
            }
        },
    },
};
</script>
